<template>
    <div>
        <b-container class="displaycontainer">
            <b-table ref="table" responsive="sm" striped :items="layoutInfopointList" :fields="fields" :small="true">
                <template #cell(uniqueId)="data">
                    <a href="#" @click.prevent="openInfopoint(data.item.uniqueId)">{{ data.item.uniqueId }}</a>
                </template>
            </b-table>
        </b-container>
    </div>
</template>

<script>

import layout from '@/store/displays/layout';

export default {
    props: ['item'],
    data() {
        return {
            layoutInfopoints: [],
        };
    },
    beforeCreate() {
        if (!this.$store.state.layout) {
            this.$store.registerModule("layout", layout);
        }
    },
    mounted() {
        this.fetchInfopointLayouts();
    },
    watch: {
        item: {
            handler() {
                this.fetchInfopointLayouts();
            },
            deep: true,
            immediate: true,
        }
    },
    computed: {
        fields() {
            return [
                { key: "uniqueId", label: 'Tunnus', sortable: true },
                { key: "name", label: 'Nimi', sortable: true }
            ];
        },
        layoutInfopointList() {
            return this.$store.state.layout.layoutInfopoints || [];
        },
        totalRows() {
            return this.layoutInfopointList.length;
        }
    },
    methods: {
        fetchInfopointLayouts() {
            try {
                this.$store.dispatch("layout/getLayoutInfopoints", this.item.id);
                this.layoutInfopoints = [...this.$store.state.layout.layoutInfopoints];
            } catch (error) {
                console.log("Error:", error);
            }
        },
        openInfopoint(uniqueId) {
            this.$router.push({ path: '/devices/infopoints', query: { id: uniqueId } });
        }
    }
};
</script>

<style scoped lang="scss">
.row {
    font-size: 0.75rem;
    white-space: pre-wrap;
}

.displaycontainer {
    font-size: 0.75rem;
    white-space: pre-wrap;
    max-height: 700px !important;
    min-height: 100px;
    overflow-y: scroll;
    overflow-x: hidden;
}
</style>
